import React from 'react';
import './Placed.css';
import studentOne from '../../../assets/Students/imagetwo.png'
import studentTwo from '../../../assets/Students/imagethree.png'
import studentThree from '../../../assets/Students/imagefour.png'

function Placed() {
    return (
        <div className='placed-outer'>
            <div className="placed-inner">
                <div className="placed-upper">
                    <h2 className='header-text'>Check our placed students</h2>
                </div>
                <div className="placed-lower">
                    <div className="placed-card">
                        <img src={studentOne} alt="Placed Student" loading='lazy'/>
                    </div>
                    <div className="placed-card">
                        <img src={studentTwo} alt="Placed Student" loading='lazy'/>
                    </div>
                    <div className="placed-card">
                        <img src={studentThree} alt="Placed Student" loading='lazy'/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Placed
